export const apolloClientQueryCacheOption = {
  fetchPolicy: 'cache-first',
  errorPolicy: 'all',
};
